<script>

    import Replacer from "./Replacer.svelte";

    let alternatives = [
        "loading michine learning moodile",
        "loading moughio leurnion mudoy",
        "loading machane lernangg modale",
        "loading m'bsers lergs' m'dole",
        "loading mopfeme lformphim mompl",
        "loading mocking lergning mogling",
        "loading monhine nernheng mondin",
        "loading mochyn lurnnyng modl",
        "loading merchine loending monise",
        "loading mechoren linting milder", 
    ];

</script>

<style>
    .progress {
        border: 0.15rem black solid;
        width: 100%;
        background: repeating-linear-gradient(
            45deg,
            #fb2,
            #fb2 0.4rem,
            #000 0.4rem,
            #000 0.8rem
    	) center/100rem;
        animation: 10s linear 0s infinite alternate slidebg;
        height: 1rem;
        border-radius: 0.5rem;
        margin-top: 1rem;
    }
    .loading-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        width: 28rem;
        margin: 0 auto;
        text-transform: uppercase;
    }
</style>

<div class="loading-container">
    <Replacer alternatives={alternatives} content="loading machine learning model" />
    <div class="progress">&nbsp;</div>
</div>